import { useState } from "react";
import {
    Button,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap";

import {
    FiMail,
    FiPhone,
    FiSend,
    FiCheckCircle,
} from "react-icons/fi";

import { toast } from "react-toastify";

import "./GetInTouch.css";
import { createEnquiry } from "../../../apiUrlConst";
import { useNavigate } from "react-router-dom";

const GetInTouch = ({
    courseName = "",
    title = "Get in Touch",
    subtitle = "Have a question or want to know more? Send us your details and our team will get back to you.",
}) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        purpose: "",
        courseCategory: "",
        courseName: courseName || "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    /* =========================================
       HANDLE INPUT
    ========================================= */

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    /* =========================================
       SUBMIT
    ========================================= */

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const submitData = {
                ...formData,

                purpose:
                    formData.purpose ||
                    (formData.courseName
                        ? `Course Enquiry - ${formData.courseName}`
                        : "General Enquiry"),
            };

            await createEnquiry(submitData);

            toast.success(
                "Thank you! Your enquiry has been submitted successfully."
            );
            const submittedCourseName = formData.courseName;

            setFormData({
                name: "",
                email: "",
                phoneNumber: "",
                purpose: "",
                courseCategory: "",
                courseName: "",
                message: "",
            });

            navigate("/thankyou", {
    state: {
        courseName: submittedCourseName,
    },
});

        } catch (error) {
            console.error("Contact enquiry error:", error);

            toast.error(
                "Unable to submit your enquiry. Please try again."
            );

        } finally {
            setLoading(false);
        }
    };

    /* =========================================
       COURSE OPTIONS
    ========================================= */

    const courseOptions = {
        "AI ML": [
            "Artificial Intelligence",
            "Data Science",
            "Machine Learning",
        ],

        "Programming": [
            "Python Programming",
            "C++",
            "C#.Net",
            "Java",
        ],

        "CAD Automation": [
            "C++ & Creo Toolkit",
            "C++ & CATIA CAA",
            "C#.Net & Solidworks API",
            "C#.Net & Nx Customization",
            "C#.Net & Autodesk Inventor API",
            "C#.Net & AutoCAD API",
            "C#.Net & Solid Edge API",
            "C#.Net & Revit API",
            "Python & CATIA CAA",
            "Python & Nx Customization",
            "NX Customization",
            "SolidWorks API",
            "CATIA CAA",
            "Creo Toolkit",
            "Revit API",
            "AutoCAD API",
            "Solid Edge API",
            "Autodesk Inventor API",
        ],

        "PLM Automation": [
            "Java & Windchill",
            "C++ & Team center",
            "Windchill",
            "Teamcenter",
        ],
        "Other": [
            "Other"
        ]
    };

    return (
        <section className="get-in-touch-section">
            <Container>

                <Row className="get-in-touch-row">

                    {/* =====================================
                        LEFT CONTENT
                    ===================================== */}

                    <Col
                        lg="5"
                        md="12"
                        className="get-in-touch-info-col"
                    >

                        <div className="get-in-touch-info">

                            {/* Badge */}

                            <span className="get-in-touch-badge">
                                <FiSend />
                                GET IN TOUCH
                            </span>

                            {/* Title */}

                            <h2>
                                {title}
                            </h2>

                            {/* Description */}

                            <p className="get-in-touch-description">
                                {subtitle}
                            </p>

                            {/* Course */}

                            {courseName && (
                                <div className="get-in-touch-course">

                                    <FiCheckCircle />

                                    <div>
                                        <span>
                                            Interested in
                                        </span>

                                        <strong>
                                            {courseName}
                                        </strong>
                                    </div>

                                </div>
                            )}

                            {/* Contact Details */}

                            <div className="get-in-touch-contact-list">

                                {/* Email */}

                                <div className="get-in-touch-contact">

                                    <div className="get-in-touch-contact-icon">
                                        <FiMail />
                                    </div>

                                    <div>
                                        <span>
                                            Email
                                        </span>

                                        <strong>
                                            contact@feesworth.com
                                        </strong>
                                    </div>

                                </div>

                                {/* Phone */}

                                <div className="get-in-touch-contact">

                                    <div className="get-in-touch-contact-icon">
                                        <FiPhone />
                                    </div>

                                    <div>
                                        <span>
                                            Contact
                                        </span>

                                        <strong>
                                            8884442747
                                        </strong>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </Col>

                    {/* =====================================
                        FORM
                    ===================================== */}

                    <Col
                        lg="7"
                        md="12"
                        className="get-in-touch-form-col"
                    >

                        <div className="get-in-touch-form-card">

                            {/* Form Header */}

                            <div className="d-flex">
                                <div className="get-in-touch-form-header">

                                    <h3>
                                        Send us a message
                                    </h3>

                                    <p>
                                        Fill in the details below and we'll
                                        get back to you shortly.
                                    </p>

                                </div>

                               

                            </div>



                            <Form onSubmit={handleSubmit}>

                                {/* =================================
                                    NAME / EMAIL / PHONE
                                ================================= */}

                                <Row>

                                    {/* Name */}

                                    <Col
                                        md="4"
                                        className="get-in-touch-form-group"
                                    >

                                        <FormGroup>

                                            <Input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                                placeholder="Full Name"
                                            />

                                        </FormGroup>

                                    </Col>

                                    {/* Email */}

                                    <Col
                                        md="4"
                                        className="get-in-touch-form-group"
                                    >

                                        <FormGroup>

                                            <Input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                placeholder="Email Address"
                                            />

                                        </FormGroup>

                                    </Col>

                                    {/* Phone */}

                                    <Col
                                        md="4"
                                        className="get-in-touch-form-group"
                                    >

                                        <FormGroup>

                                            <Input
                                                type="tel"
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                required
                                                placeholder="Phone Number"
                                            />

                                        </FormGroup>

                                    </Col>

                                </Row>

                                {/* =================================
                                    COURSE CATEGORY / COURSE
                                ================================= */}

                                <Row>

                                    <Col md={6}>
                                        <FormGroup>

                                            <Label className="fw-semibold">
                                                Course Category *
                                            </Label>

                                            <Input
                                                type="select"
                                                name="courseCategory"
                                                value={formData.courseCategory}
                                                onChange={handleChange}
                                                required
                                                className="rounded-pill px-3 py-2 shadow-sm"
                                            >

                                                <option value="">
                                                    Select Category
                                                </option>

                                                <option value="AI ML">
                                                    AI ML
                                                </option>

                                                <option value="Programming">
                                                    Programming
                                                </option>

                                                <option value="CAD Automation">
                                                    CAD Automation
                                                </option>

                                                <option value="PLM Automation">
                                                    PLM Automation
                                                </option>
                                                <option value="Other">
                                                    Other
                                                </option>

                                            </Input>

                                        </FormGroup>
                                    </Col>

                                    <Col md={6}>
                                        <FormGroup>

                                            <Label className="fw-semibold">
                                                Course Name *
                                            </Label>

                                            <Input
                                                type="select"
                                                name="courseName"
                                                value={formData.courseName}
                                                onChange={handleChange}
                                                required
                                                disabled={!formData.courseCategory}
                                                className="rounded-pill px-3 py-2 shadow-sm"
                                            >

                                                <option value="">
                                                    Select Course
                                                </option>

                                                {formData.courseCategory &&
                                                    courseOptions[
                                                        formData.courseCategory
                                                    ]?.map((course, index) => (
                                                        <option
                                                            key={index}
                                                            value={course}
                                                        >
                                                            {course}
                                                        </option>
                                                    ))}

                                            </Input>

                                        </FormGroup>
                                    </Col>

                                </Row>

                                {/* =================================
                                    MESSAGE
                                ================================= */}

                                <Row>

                                    <Col
                                        xs="12"
                                        className="get-in-touch-form-group"
                                    >

                                        <FormGroup>

                                            <Input
                                                type="textarea"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                rows="5"
                                                placeholder="Write your message..."
                                            />

                                        </FormGroup>

                                    </Col>

                                </Row>

                                {/* =================================
                                    SUBMIT
                                ================================= */}

                                <Button
                                    type="submit"
                                    disabled={loading}
                                     className="get-in-touch-submit"
                                >

                                    {loading ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            />

                                            Submitting...
                                        </>
                                    ) : (
                                        <>
                                            <FiSend />

                                            Submit Enquiry
                                        </>
                                    )}

                                </Button>

                            </Form>

                        </div>

                    </Col>

                </Row>

            </Container>
        </section>
    );
};

export default GetInTouch;